import AuthActions from "../actions/authAction";

const AuthReducer = (
  state = { isLoggedIn: false, isLoading: false },
  action
) => {
  switch (action.type) {
    case AuthActions.AUTHENTICATION:
      return {
        ...state,
        isLoggedIn: false,
        isLoading: true,
        user: ''
      };
    case AuthActions.AUTHENTICATION_SUCCESSFUL:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: true,
        user: action
      };

    // authentication verifcation
    case AuthActions.AUTHENTICATION_VERIFICATION:
      return {
        isLoading: false,
        isLoggedIn: false,
      };

    case AuthActions.AUTHENTICATION_FAILED:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: false
      };

    // user verification
    case AuthActions.VERIFICATION_REQUEST:
      return {
        ...state,
        isLoggedIn: false,
        isLoading: true,
        user: ''
      };
    case AuthActions.VERIFICATION_SUCCESSFULL:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: true,
        user: action
      };
    case AuthActions.VERIFICATION_FAILED:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: false
      };

    // user change password
    case AuthActions.CHANGEPASSWORD_REQUEST:
      return {
        ...state,
        isLoading: true,
        user: ''
      };
    case AuthActions.CHANGEPASSWORD_SUCCESSFULL:
      return {
        ...state,
        isLoading: false,
        user: action
      };
    case AuthActions.CHANGEPASSWORD_FAILED:
      return {
        ...state,
        isLoading: false,
        isLoggedIn: false
      };


    case AuthActions.LOGOUT:
      return {};
    default:
      return {
        ...state
      };
    //   break;
  }
};

export default AuthReducer;
